/* eslint-disable no-param-reassign */
import rootAPIs from '@/api/rootAPIs';

const state = {
  trackingCartId: null,
  validationData: {},
  validationBypassCode: null,
  formToken: null,
};

const mutations = {
  setFormToken(customerDataState, formToken) {
    customerDataState.formToken = formToken;
    rootAPIs.setFormToken(formToken);
  },
  setValidationData(customerDataState, validationData) {
    customerDataState.validationData = { ...customerDataState.validationData, ...validationData };
  },
  setValidationBypassCode(customerDataState, validationBypassCode) {
    customerDataState.validationBypassCode = validationBypassCode;
  },
  removeValidationBypassCode(customerDataState) {
    customerDataState.validationBypassCode = null;
  },
  setTrackingCartId(customerDataState, trackingCartId) {
    customerDataState.trackingCartId = trackingCartId;
  },
};

const actions = {
  /**
   * Fetches product data from the Rebate server using the application
   *
   * @param commit A function that allows sending mutations to the store
   * @param customerId The id of the customer cache entry
   */
  fetchValidationData({ commit }, customerId) {
    rootAPIs.getCustomerValidationData(customerId)
      .then((validationData) => {
        validationData.customerId = customerId;
        commit('setValidationData', validationData);
      })
      .catch(() => {});
  },
  /**
   * Fetches customer data associated with a validation bypass code.
   *
   * @param commit A function that allows sending mutations to the store
   * @param payload An object containing a bypassCode string
   * and a utilityID int.
   */
  fetchValidationBypassData({ commit }, payload) {
    const { bypassCode, utilityID } = payload;
    return rootAPIs.getUserDataFromBypassCode(bypassCode, utilityID)
      .then((data) => {
        if (data.is_valid) {
          commit('setValidationData', data);
        }
        return data;
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
